import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { DEFAULT_DEXT_TAGS_OTHER_INPUT_LENGTH, FIELD_TYPES } from '../../../constants';
import { TagsFieldWUT } from '../../../ui/tags-field';
export const DextTagsWUT = props => {
  const fieldType = FIELD_TYPES.DEXT_TAGS;
  return /*#__PURE__*/React.createElement(TagsFieldWUT, _extends({}, props, {
    fieldType: fieldType,
    otherInputCharacterLimit: DEFAULT_DEXT_TAGS_OTHER_INPUT_LENGTH
  }));
};
//# sourceMappingURL=dext-tags-wut.js.map